import React, { Component } from 'react';
import api from "./../../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import GetNumeric from './GetName';
import { user_token } from './../../../../services/Auth';

//import da API
import { professional } from './../../../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);
var area = localStorage.getItem('professional_area');
var speciality = localStorage.getItem('medical_area');



//Classe para API
export default class DataExam extends Component {
  state = {
    exames: [],
    usuarios: [],
  }

  componentDidMount() {
    this.loadData();
    //  alert(teste);
  }



  loadData = async () => {
    var request;
    if (area === "Medicina") {
      //request = await api.get(`/exam?status=Pendente&appointment_type=${area}&medical_specialty=${speciality}`, {headers: {'x-access-token': token}});
      request = await apiProfessional.getAllExams(
        [
          {
            header: 'status',
            value: 'Pendente'
          },
          {
            header: 'appointment_type',
            value: area
          },
          {
            header: 'medical_appointment_type',
            value: speciality
          },
        ]);
    } else {
      //request = await api.get(`/exam?status=Pendente&appointment_type=${area}`, {headers: {'x-access-token': token}});
      request = await apiProfessional.getAllExams(
        [
          {
            header: 'status',
            value: 'Pendente'
          },
          {
            header: 'appointment_type',
            value: area
          },
        ]);
    };
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });
  };



  render() {
    return (
      <>

        <div id="lista-style">

          {this.state.exames.map(exam => (
            <>
              <NavLink to={{ pathname: '/tela_ps_cpe/' + exam._id }}>
                <button id="option-PS-Painel" key={exam._id}><GetNumeric user_id={exam.user_id} /></button>
              </NavLink>
            </>
          ))}
        </div>
      </>

    );
  }

}

/*
  Código Original
  <button id="option-PS-Painel" key={exam._id}><GetName user_id = {exam.user_id}/></button>
*/
